import React, { useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { BiLoaderAlt } from 'react-icons/bi';
import config from '../../config';
import useClient from '../../hooks/useClient';

const UnlinkAccount = () => {
  const client = useClient();
  const { platform } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    switch (platform) {
      case 'psn': {
        client
          .post(`${config.everywhereApi}/users/self/profile/unlink-psn-account`)
          .then(() => {
            navigate('/account?tab=PSN&unlink=true');
          })
          .catch(() => {
            navigate('/account?tab=PSN&fail=true&unlink=true');
          });
        break;
      }
      default:
        console.error('Invalid TPA platform');
    }

    // Handle timeouts
    const timeoutId = setTimeout(() => {
      navigate('/account?tab=PSN&fail=true&unlink=true');
    }, 10 * 1000);
    return () => clearTimeout(timeoutId);
  }, [platform]);

  return (
    <div className="h-screen flex flex-col items-center justify-center">
      <BiLoaderAlt className="mb-20 animate-spin text-4xl" />
      <span className="text-lg mb-4">Unlinking account...</span>
      <span className="text-sm text-gray">You will be redirected shortly.</span>
    </div>
  );
};

export default UnlinkAccount;
